var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('img',{attrs:{"src":require("../../assets/images/allimg/200103/shouce.jpg"),"alt":"使用手册"}})])}]

export { render, staticRenderFns }